import { Sun } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Label } from "../ui/label";

/**
 * SundayWorkDialog — reason-capture modal shown when an employee checks in on a Sunday (overtime).
 *
 * Props:
 *  - open, onClose : dialog state + close handler
 *  - reason, setReason : controlled textarea value
 *  - onConfirm : () => void  — called when the user clicks "Check In (Overtime)"
 */
const SundayWorkDialog = ({ open, onClose, reason, setReason, onConfirm }) => (
  <Dialog open={open} onOpenChange={onClose}>
    <DialogContent data-testid="sunday-work-modal">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Sun className="text-amber-500" size={20} />
          Sunday Work - Overtime Day
        </DialogTitle>
      </DialogHeader>
      <div className="space-y-4">
        <div className="p-4 bg-amber-50 rounded-lg border border-amber-200">
          <p className="text-sm text-amber-800">
            <strong>Note:</strong> Today is Sunday. Working on Sunday is considered overtime and will be paid additionally.
            Please provide a reason for working today.
          </p>
        </div>
        <div className="space-y-2">
          <Label htmlFor="sunday-reason">Reason for Sunday Work *</Label>
          <textarea
            id="sunday-reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-prepify-500/20 focus:border-prepify-500 min-h-[100px]"
            placeholder="E.g., Urgent project deadline, Client meeting, System maintenance..."
            data-testid="sunday-reason-input"
          />
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={onConfirm} className="bg-amber-600 hover:bg-amber-700" data-testid="sunday-checkin-btn">
            <Sun size={16} className="mr-2" />
            Check In (Overtime)
          </Button>
        </DialogFooter>
      </div>
    </DialogContent>
  </Dialog>
);

export default SundayWorkDialog;
